import React from "react";
import { NavigateFunction } from "react-router-dom";
import PromoIcon from "../../../../../images/products/promotion-image.svg";
import { CountryWithStateModel, PromotionRelatedGridModel } from "../models";
import {
  ITableHeaders,
  TableWithHeaderButtons,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import PlaceholderSmallerGrid from "./PlaceholderSmallerGrid";
import TableGrid from "./TableGrid";

type IProps = {
  navigate: NavigateFunction;
  promoCodes: PromotionRelatedGridModel[];
  countriesWithState: CountryWithStateModel[];
};
const RelatedPromoCodesGrid: React.FC<IProps> = ({ promoCodes, countriesWithState }) => {
  const headers = () => {
      const columns: ITableHeaders<PromotionRelatedGridModel>[] = [
          {
              dataKey: 'type',
              title: 'Type',
              onCellRender: (data: PromotionRelatedGridModel) => {
                  return data.type;
              },
          },
          {
              dataKey: 'name',
              title: 'Name',
              onCellRender: (data: PromotionRelatedGridModel) => {
                  return data.name;
              },
          },

          {
              dataKey: 'discount',
              title: 'Discount',
              onCellRender: (data: PromotionRelatedGridModel) => {
                  return data.discount;
              },
          },
          {
              dataKey: 'limitations',
              title: 'Limitations',
              onCellRender: (data: PromotionRelatedGridModel) => {
                  return data.limitations;
              },
          },
          {
              dataKey: 'promoCode',
              title: 'Promo Code',
              onCellRender: (data: PromotionRelatedGridModel) => {
                  return data.promoCode;
              },
          },
      ];
      return columns;
  };

  if (promoCodes.length == 0)
      return <PlaceholderSmallerGrid title="No Promotion Codes" icon={PromoIcon} buttonCaption="New" />;

  return (
      <TableGrid
          wrapperClassName="table-with-header-btns"
          tableHeader={
              <TableWithHeaderButtons
                  isShowHeaderButton={true}
                  totalItems={promoCodes.length}
                  icon={PromoIcon}
                  title="Promotion Applied"
              />
          }
          cellSpacing={20}
          headers={headers()}
          data={promoCodes}
          totalItemCount={promoCodes.length}
          countriesWithState={countriesWithState}
      />
  );
};

export default withRouter(RelatedPromoCodesGrid);
